export const TOGGLE_COMPETITOR_STATUS_REQUEST =
  "TOGGLE_COMPETITOR_STATUS_REQUEST";
export const TOGGLE_COMPETITOR_STATUS_SUCCESS =
  "TOGGLE_COMPETITOR_STATUS_SUCCESS";
export const TOGGLE_COMPETITOR_STATUS_FAILURE =
  "TOGGLE_COMPETITOR_STATUS_FAILURE";

export const toggleCompetitorStatusRequest = (payload) => ({
  type: TOGGLE_COMPETITOR_STATUS_REQUEST,
  payload,
});

export const toggleCompetitorStatusSuccess = (payload) => ({
  type: TOGGLE_COMPETITOR_STATUS_SUCCESS,
  payload,
});

export const toggleCompetitorStatusFailure = (error) => ({
  type: TOGGLE_COMPETITOR_STATUS_FAILURE,
  error,
});
